import React from 'react';

export default function SkeletonText({ width = '80px', height = '14px', className = '', inline = false }) {
  return (
    <span
      className={`skeleton-shimmer rounded ${className}`}
      style={{
        display: inline ? 'inline-block' : 'block',
        width,
        height,
        verticalAlign: inline ? 'middle' : undefined,
      }}
      aria-hidden="true"
    />
  );
}
